import { LucideIcon, LucideProps } from "lucide-react";
import { forwardRef } from "react";

const Glaci: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(
  (props, ref) => {
    return (
      <svg
        {...props}
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="256 224 512 640"
        className={`glaci-icon ${props.className || ""}`}
      >
        <path
          className="glaci-mid"
          d="M436.398,255.87743,601.6284,344.63237c8.387,4.50517,5.18622,17.228-4.33422,17.228H266.83344c-9.52044,0-12.72125-12.72282-4.33422-17.228l165.23037-88.75494A9.15923,9.15923,0,0,1,436.398,255.87743Z"
        />
        <path
          className="glaci-dark"
          d="M719.11083,383.412H590.80322a27.01248,27.01248,0,0,0-10.32,2.0418H389.4424c-35.41868,0-59.37228,38.89369-45.59166,74.0277L485.45589,820.50765c17.02685,43.4103,74.15651,43.4103,91.18331,0l49.795-126.95367.52615,2.24466c7.33947,31.31079,48.65379,31.31079,55.99326,0l64.15383-273.68455C751.71148,402.47308,737.92293,383.412,719.11083,383.412Z"
        />
        <path
          className="glaci-mid"
          d="M627.54374,620.86571c-18.36535-24.9108-55.00519-38.361-63.627-59.7143-12.8973-31.94226,11.58226-60.20448,27.6398-78.3511,22.97269-25.96146,30.3926-37.36535,32.169-55.2508.88436-8.904-.5379-24.0991-17.2919-44.19724l-193.65891.09165c-40.12243,0-67.84174,43.22839-53.626,83.62986l51.90734,163.60157L472.429,789.01815c2.93282-1.58495,124.93169-42.89568,156.88763-100.18677C649.35911,652.89889,631.5891,626.35284,627.54374,620.86571Z"
        />
        <path
          className="glaci-light"
          d="M447.59087,383.57883l-157.06764.25042c-18.051,0-30.11225,20.02487-22.75095,37.77271l93.24656,224.81433c4.39359,10.59275,13.57229,15.88913,22.751,15.88913s18.35741-5.29637,22.751-15.88913l5.198-13.06338a209.9049,209.9049,0,0,1-10.17628-32.51961,221.83226,221.83226,0,0,1-4.69677-65.96812c1.43144-18.61279,2.63477-34.2594,10.95907-51.10212,4.26432-8.62806,10.4099-17.21133,22.70106-34.37775C442.91748,432.05072,469.44764,403.09821,447.59087,383.57883Z"
        />
        <path
          className="glaci-bright"
          d="M724.50256,333.52122,563.30287,239.46063a12.17136,12.17136,0,0,0-12.24734,0L517.084,259.28312a13.58217,13.58217,0,0,0,.5019,23.81838l130.135,68.9074a30.68914,30.68914,0,0,0,14.35725,3.56055H718.3789C730.60928,355.56945,735.02728,339.66243,724.50256,333.52122Z"
        />
        <path
          className="glaci-light"
          d="M432.06645,361.58566a39.0069,39.0069,0,0,1-7.41248-11.70227c-6.04623-14.39058-.10289-22.66656-4.76514-38.80222-1.00935-3.49326-4.54331-14.372-13.766-22.78861a39.132,39.132,0,0,0-12.9783-7.90871,16.09984,16.09984,0,0,0-13.15,1.00323L286.62514,331.717a16.25131,16.25131,0,0,0-7.10989,7.6236l0,0c-3.28878,7.28514-.3767,21.0516,13.5794,22.52066"
        />
      </svg>
    );
  },
);

Glaci.displayName = "Glaci";

export default Glaci;
